import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Auth from './components/Auth';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home/index';
import Persona from './pages/Persona';
import GeneratePersonas from './pages/GeneratePersonas';

const About: React.FC = () => {
    return <div>About</div>;
};

const AppContent: React.FC = () => {
    const location = useLocation();

    // Define routes where Navbar should not appear
    const navbarExcludedRoutes = ['/personas', '/generate-personas'];
    const shouldShowNavbar = !navbarExcludedRoutes.some(route =>
        location.pathname.startsWith(route)
    );    

    return (
        <div>
            {shouldShowNavbar && <Navbar title="Spear Growth" />}
            <Routes>
                <Route path="/personas" element={<Persona />} />
                <Route path="/generate-personas" element={<GeneratePersonas />} />
                <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
                <Route path="/about" element={<ProtectedRoute><About /></ProtectedRoute>} />
                <Route path="/auth/linkedin/callback" element={<Auth />} />
            </Routes>
        </div>
    );
};

const App: React.FC = () => {
    return (
        <AuthProvider>
            <BrowserRouter>
                <AppContent />
            </BrowserRouter>
        </AuthProvider>
    );
};

export default App;
